import { render, staticRenderFns } from "./document_form.vue?vue&type=template&id=3a47aa0e&"
import script from "./document_form.vue?vue&type=script&lang=js&"
export * from "./document_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports